import { Button } from 'antd';
import { DndContext, closestCenter, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { arrayMove, SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { TagFamilyMemberType } from '../../../../../schemas/index';
import SortableTagNode from './SortableTagNode';
import { PlusIcon } from '@phosphor-icons/react';
import { defaultNode } from './utils';
import { Fragment } from 'react';

function TagChildrenEditor({
  nodes,
  parentPath,
  onChange,
  onDelete,
  onAddChild,
  onSort,
  level = 0,
}: {
  nodes: Array<TagFamilyMemberType>;
  parentPath: Array<number>;
  onChange: (path: Array<number>, newNode: TagFamilyMemberType) => void;
  onDelete: (path: Array<number>) => void;
  onAddChild: (path: Array<number>, child: TagFamilyMemberType) => void;
  onSort: (path: Array<number>, newNodes: Array<TagFamilyMemberType>) => void;
  level?: number;
}) {
  const sensors = useSensors(useSensor(PointerSensor));

  const getId = (idx: number) => [...parentPath, idx].join('-');

  const handleDragEnd = (event: any) => {
    const { active, over } = event;
    if (active.id !== over?.id) {
      const oldIndex = nodes.findIndex((_, i) => getId(i) === active.id);
      const newIndex = nodes.findIndex((_, i) => getId(i) === over.id);
      const newNodes = arrayMove(nodes, oldIndex, newIndex);
      onSort(parentPath, newNodes);
    }
  };

  return (
    <div
      style={{
        width: 'max-content',
        background: 'transparent',
      }}
    >
      <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
        <SortableContext
          items={nodes.map((_, i) => getId(i))}
          strategy={verticalListSortingStrategy}
        >
          {nodes.map((node, idx) => (
            <Fragment key={getId(idx)}>
              <SortableTagNode
                id={getId(idx)}
                node={node}
                path={[...parentPath, idx]}
                onChange={onChange}
                onDelete={onDelete}
                onAddChild={onAddChild}
                onSort={onSort}
                level={level}
              />
              <div
                style={{
                  border: '1px solid transparent',
                  margin: '12px 0',
                }}
              />
            </Fragment>
          ))}
        </SortableContext>
      </DndContext>
      {parentPath.length > 0 && (
        <Button
          icon={<PlusIcon />}
          size="small"
          style={{ marginTop: 8 }}
          onClick={() => {
            onAddChild(parentPath, defaultNode());
          }}
        >
          Add Child
        </Button>
      )}
    </div>
  );
}

export default TagChildrenEditor;
